<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core'
const nuxtApp = useNuxtApp()
const { activeHeadings, updateHeadings } = useScrollspy()
const { y } = useWindowScroll()

const links = computed(() => {
  let activeHeading = ''

  if (y.value < 10) {
    activeHeading = 'hero'
  } else if (activeHeadings.value.includes('faq')) {
    activeHeading = 'faq'
  } else if (activeHeadings.value.includes('appointments')) {
    activeHeading = 'appointments'
  } else {
    activeHeading = 'services'
  }

  return [
    {
      active: activeHeading === 'services',
      icon: 'i-mdi-document-sign',
      label: 'Services',
      to: '#services',
    }, {
      active: activeHeading === 'appointments',
      icon: 'i-mdi-calendar-clock',
      label: 'Appointments',
      to: '#appointments',
    }, {
      active: activeHeading === 'faq',
      icon: 'i-mdi-faq',
      label: 'FAQ',
      to: '#faq',
    },
  ]
})

nuxtApp.hooks.hookOnce('page:finish', () => {
  updateHeadings([
    document.querySelector('#services'),
    document.querySelector('#appointments'),
    document.querySelector('#faq'),
  ].filter(x => x !== null))
})
</script>

<template>
  <UHeader :links="links">
    <template #logo>
      <div class="font-custom font-semibold">
        Julia's Mobile Notary
      </div>
    </template>

    <template #right>
      <UButton
        label="Booking Now"
        color="primary"
        variant="outline"
        leading-icon="i-mdi-bell-notification-outline"
        class="hidden lg:flex"
        to="#appointments"
      />
    </template>

    <template #panel>
      <UAsideLinks :links="links"/>

      <UDivider class="my-6"/>

      <UButton
        label="Booking Now"
        color="primary"
        variant="outline"
        leading-icon="i-mdi-bell-notification-outline"
        block
        class="mb-3"
      />
    </template>
  </UHeader>
</template>
